import { useLocation, useParams } from "react-router-dom";
import { useContent } from "../contexts/contentContext/contentContext";
import { useEffect, useState } from "react";

const usePageInit = () => {
  const params = useParams();
  const location = useLocation();
  const {
    fetchConsts,
    fetchSupportCategories,
    fetchSupportQuestionsList,
    fetchSupportSingleQuestion,
    fetchAndSetMetaData,
    fetchAndSetBannersData,
    getLanguage,
  } = useContent();

  const lang = getLanguage();

  const [isPageReady, setIsPageReady] = useState(false);

  const _getPageName = () => {
    return location.pathname.includes("/user/")
      ? location.pathname.split("/user/")[1].split("/")[1]
      : location.pathname.includes(`/${lang}/`) &&
          location.pathname.split(`/${lang}/`)[1].split("/")[0];
  };

  const fetchPageContent = async () => {
    const pageName = _getPageName();

    await fetchConsts(() => {});
    await fetchAndSetBannersData(pageName, () => {});
    await fetchAndSetMetaData(pageName, () => {});
    await fetchSupportCategories(() => {});
    await fetchSupportQuestionsList(params.supportCategory, () => {});
    await fetchSupportSingleQuestion(params.supportQuestion, () => {});
    setIsPageReady(true);
  };

  useEffect(() => {
    fetchPageContent();
  }, []);

  return {
    isPageReady
  };
};

export default usePageInit;
